import { postIFIModule } from '../../config/apiSinToken'
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: INSERT MIPYME BY IFI
 * FECHA: 10-8-2022
 */
export const createMIPYMEIFI = async (form) => {
  const data = await postIFIModule(`api/v1/Users/InsertMiPymeUser`, form)
  return data
}

/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: INSERT PRE-ELEGIBILITY FORM
 * FECHA: 22-8-2022
 */
export const createForm = async (form) => {
  const data = await postIFIModule(
    `api/v1/Forms/InsertFormPreElegibility`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Reasignar Usuario existente
 * FECHA: 22-7-2024
 */
export const ReassignUserMiPyme = async (b2c, idMipyme, idNewUser) => {
  const data = await postIFIModule(
    `api/v1/MiPymes/ReassignUserMiPyme/${b2c}/${idMipyme}/${idNewUser}`,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Reasignar Usuario nuevo
 * FECHA: 22-7-2024
 */
export const ReassignUserMiPymeNew = async (param, form) => {
  const data = await postIFIModule(
    `api/v1/MiPymes/ReassignUserMiPyme/${param}/NewUser`,
    form,
  )
  return data
}
